import { useNavigate } from 'react-router-dom'
import { User, LogOut, FileText, HelpCircle } from 'lucide-react'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000'

function UserMenu() {
  const navigate = useNavigate()
  const apiBaseUrl = API_URL.startsWith('http') ? new URL(API_URL).origin : window.location.origin
  const apiDocsUrl = `${apiBaseUrl}/api/docs`

  const handleLogout = () => {
    navigate('/logout')
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          className="w-10 h-10 rounded-full bg-black text-white flex items-center justify-center hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-black"
          aria-label="User menu"
        >
          <User className="h-5 w-5" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48 rounded-none">
        <DropdownMenuItem onClick={() => navigate('/profile')} className="cursor-pointer">
          <User className="mr-2 h-4 w-4" />
          Profile
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => navigate('/help')} className="cursor-pointer" data-testid="help-link">
          <HelpCircle className="mr-2 h-4 w-4" />
          Help
        </DropdownMenuItem>
        <DropdownMenuItem asChild className="cursor-pointer">
          <a
            href={apiDocsUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="api-docs-link"
          >
            <FileText className="mr-2 h-4 w-4" />
            API Docs
          </a>
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={handleLogout} className="cursor-pointer">
          <LogOut className="mr-2 h-4 w-4" />
          Logout
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

export default UserMenu
